import { render, staticRenderFns } from "./TournamentsParticipants.vue?vue&type=template&id=185f6f85"
import script from "./TournamentsParticipants.vue?vue&type=script&lang=js"
export * from "./TournamentsParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports